var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "admin-plan-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.proceed.apply(null, arguments)
        },
        keydown: function ($event) {
          return _vm.currencyForm.errors.clear($event.target.name)
        },
      },
    },
    [
      _c("div", { staticClass: "row admin-plan-form__row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-sm-6 form-group" },
          [
            _c("label", { attrs: { for: "" } }, [
              _vm._v(_vm._s(_vm.trans("currency.name")) + " "),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currencyForm.name,
                  expression: "currencyForm.name",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                value: "",
                name: "name",
                placeholder: _vm.trans("currency.name"),
              },
              domProps: { value: _vm.currencyForm.name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.currencyForm, "name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("show-error", {
              attrs: { "form-name": _vm.currencyForm, "prop-name": "name" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-6 form-group" },
          [
            _c("label", { attrs: { for: "" } }, [
              _vm._v(_vm._s(_vm.trans("currency.symbol"))),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currencyForm.symbol,
                  expression: "currencyForm.symbol",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                value: "",
                name: "symbol",
                placeholder: _vm.trans("currency.symbol"),
              },
              domProps: { value: _vm.currencyForm.symbol },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.currencyForm, "symbol", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("show-error", {
              attrs: { "form-name": _vm.currencyForm, "prop-name": "symbol" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-6 form-group" },
          [
            _c("label", { attrs: { for: "" } }, [
              _vm._v(_vm._s(_vm.trans("currency.decimal_place"))),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currencyForm.decimal_place,
                  expression: "currencyForm.decimal_place",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                value: "",
                name: "decimal_place",
                placeholder: _vm.trans("currency.decimal_place"),
              },
              domProps: { value: _vm.currencyForm.decimal_place },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.currencyForm,
                    "decimal_place",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("show-error", {
              attrs: {
                "form-name": _vm.currencyForm,
                "prop-name": "decimal_place",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group mb-0" },
        [
          _c("label", [_vm._v(_vm._s(_vm.trans("currency.position")))]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-wrap align-items-center" }, [
            _c("div", { staticClass: "radio radio-success mr-3 mb-1" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currencyForm.position,
                    expression: "currencyForm.position",
                  },
                ],
                attrs: {
                  type: "radio",
                  value: "prefix",
                  id: "position_prefix",
                  name: "position",
                },
                domProps: {
                  checked: _vm.currencyForm.position === "prefix",
                  checked: _vm._q(_vm.currencyForm.position, "prefix"),
                },
                on: {
                  click: function ($event) {
                    return _vm.currencyForm.errors.clear("position")
                  },
                  change: function ($event) {
                    return _vm.$set(_vm.currencyForm, "position", "prefix")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "position_prefix" } }, [
                _vm._v(_vm._s(_vm.trans("currency.prefix"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "radio radio-success mb-1" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currencyForm.position,
                    expression: "currencyForm.position",
                  },
                ],
                attrs: {
                  type: "radio",
                  value: "suffix",
                  id: "position_suffix",
                  name: "position",
                },
                domProps: {
                  checked: _vm.currencyForm.position === "suffix",
                  checked: _vm._q(_vm.currencyForm.position, "suffix"),
                },
                on: {
                  click: function ($event) {
                    return _vm.currencyForm.errors.clear("position")
                  },
                  change: function ($event) {
                    return _vm.$set(_vm.currencyForm, "position", "suffix")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "position_suffix" } }, [
                _vm._v(_vm._s(_vm.trans("currency.suffix"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("show-error", {
            attrs: { "form-name": _vm.currencyForm, "prop-name": "position" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "admin-plan-form__switches" }, [
        _c(
          "div",
          { staticClass: "admin-plan-form__switch-row" },
          [
            _c("div", { staticClass: "admin-plan-form__switch-meta" }, [
              _c("span", { staticClass: "admin-plan-form__switch-label" }, [
                _vm._v(_vm._s(_vm.trans("currency.default"))),
              ]),
            ]),
            _vm._v(" "),
            _c("switches", {
              attrs: { theme: "bootstrap", color: "success" },
              model: {
                value: _vm.currencyForm.is_default,
                callback: function ($$v) {
                  _vm.$set(_vm.currencyForm, "is_default", $$v)
                },
                expression: "currencyForm.is_default",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "admin-plan-form__actions" },
        [
          _c(
            "button",
            {
              staticClass:
                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
              attrs: { type: "submit" },
            },
            [
              _c("admin-icon", { attrs: { name: "check" } }),
              _vm._v(" "),
              _vm.id
                ? _c("span", [_vm._v(_vm._s(_vm.trans("general.update")))])
                : _c("span", [_vm._v(_vm._s(_vm.trans("general.save")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.id,
                  expression: "id",
                },
              ],
              staticClass: "btn btn-sm admin-form-btn-cancel",
              attrs: { to: "/currency" },
            },
            [
              _c("admin-icon", {
                staticClass: "mr-1",
                attrs: { name: "close" },
              }),
              _vm._v(_vm._s(_vm.trans("general.cancel"))),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }